<ngx-loading-bar color="#3173D6"></ngx-loading-bar>
